import { render, staticRenderFns } from "./DownloadWill.vue?vue&type=template&id=131f6f50"
import script from "./DownloadWill.vue?vue&type=script&lang=js"
export * from "./DownloadWill.vue?vue&type=script&lang=js"
import style0 from "./DownloadWill.vue?vue&type=style&index=0&id=131f6f50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports